const NAMES = {
    ajaxModuleUpdate: 'ajax-module-update-event',
    allCatsLinkClicked: 'all-cats-link-clicked-event',
    changeToTab: 'change-to-tab-event',
    stickyHeaders: 'sticky-headers-event',
    stickyLeftNav: 'sticky-left-nav-event',
    tabHasChanged: 'str-tab-change-event',
    toggleLeftNav: 'toggle-left-nav-event',
    toggleLeftNavDone: 'toggle-left-nav-done-event'
};

export default {
    ajaxModuleUpdate: newEvent(NAMES.ajaxModuleUpdate),
    allCatsLinkClicked: newEvent(NAMES.allCatsLinkClicked),
    changeToTab: newEvent(NAMES.changeToTab),
    stickyHeaders: newEvent(NAMES.stickyHeaders),
    stickyLeftNav: newEvent(NAMES.stickyLeftNav),
    tabHasChanged: newEvent(NAMES.tabHasChanged),
    toggleLeftNav: newEvent(NAMES.toggleLeftNav),
    toggleLeftNavDone: newEvent(NAMES.toggleLeftNavDone)
};

function newEvent(eventName) {
    return {
        listen: callback => {
            document.addEventListener(eventName, evt => {
                callback(evt.detail);
            });
        },
        dispatch: data => {
            const tabEvt = new CustomEvent(eventName, { detail: data });
            document.dispatchEvent(tabEvt);
        }
    };
}
